import {
	PRIORITY_TYPE as PriorityKey,
	PARENT_TYPE as ParentKey,
	HIERARCHY_LEVEL_ABOVE as HierarchyLevelAboveKey,
} from '@atlassian/jira-platform-field-config';
import { TimeEstimateKey, StatusKey, AssigneeKey } from '@atlassian/jira-providers-issue';

export const extractedFixedFields: string[] = [
	TimeEstimateKey,
	StatusKey,
	AssigneeKey,
	PriorityKey,
	ParentKey,
	HierarchyLevelAboveKey,
];
